import { render, staticRenderFns } from "./Oteador.vue?vue&type=template&id=6d63b5be&scoped=true"
import script from "./Oteador.vue?vue&type=script&lang=js"
export * from "./Oteador.vue?vue&type=script&lang=js"
import style0 from "./Oteador.vue?vue&type=style&index=0&id=6d63b5be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d63b5be",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Oteador/Oteador.vue
// module id = wwvz
// module chunks = 41